"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var theme_1 = require("../../../theme");
var PADDING = {
    small: 52,
    medium: 112,
    large: 136,
};
var PADDING_COMPACT = {
    small: 32,
    medium: 40,
    large: 64,
};
var WRAPPER_JUSTIFY_CONTENT = {
    left: 'flex-start',
    center: 'center',
};
exports.Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  padding: ", " 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  @media ", " {\n    padding: ", " 0;\n    justify-content: center;\n  }\n\n  @media ", " {\n    padding: ", " 0;\n    justify-content: ", ";\n  }\n"], ["\n  position: relative;\n  padding: ", " 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  @media ", " {\n    padding: ", " 0;\n    justify-content: center;\n  }\n\n  @media ", " {\n    padding: ", " 0;\n    justify-content: ", ";\n  }\n"])), function (_a) {
    var $compact = _a.$compact;
    return ($compact ? PADDING_COMPACT.small : PADDING.small) + "px";
}, theme_1.theme.breakpoints.medium, function (_a) {
    var $compact = _a.$compact;
    return ($compact ? PADDING_COMPACT.medium : PADDING.medium) + "px";
}, theme_1.theme.breakpoints.large, function (_a) {
    var $compact = _a.$compact;
    return ($compact ? PADDING_COMPACT.large : PADDING.large) + "px";
}, function (_a) {
    var $align = _a.$align;
    return WRAPPER_JUSTIFY_CONTENT[$align];
});
var templateObject_1;
